import { render } from "./becomePartener.vue?vue&type=template&id=ffbd69e2"
import script from "./becomePartener.vue?vue&type=script&lang=js"
export * from "./becomePartener.vue?vue&type=script&lang=js"

import "./becomePartener.vue?vue&type=style&index=0&id=ffbd69e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__